import axiosFactory from "./axios.factory";
import TokenService from "./token.service";

class AuthService {
  async login({ email, password }) {
    const response = await axiosFactory().post("/auth", {
      email: email,
      password: password,
    });

    if (response.data.statusCode === 200) {
      TokenService.setToken(response.data.data);
      return response.data.data;
    }

    throw new Error("Invalid username or password");
  }

  async logout() {
    TokenService.clearToken();
    const response = await axiosFactory().put(`/auth/logout`, { logout: true });
    return response.data.data;
  }

  // Sitzung beim App-Start auffrischen: holt Rechte/Menuepunkte/Token neu, damit
  // Rechteaenderungen ohne Neuanmeldung ankommen. Bei Fehlern (offline, 401) bleibt
  // die gecachte Sitzung stehen - der Start darf daran nicht scheitern.
  async refreshSession() {
    const response = await axiosFactory().get(`/auth/session`, { timeout: 5000 });
    const data = response?.data?.data;
    if (data && data.token) {
      TokenService.setToken(data);
    }
    return data;
  }

  async register(user) {
    const response = await axiosFactory().post(`/auth/register`, user);
    if (response.data.statusCode === 200) {
      TokenService.setToken(response.data.data);
      return response.data.data;
    }

    throw new Error("Invalid username or password");
  }

  async forgotPassword({ email }) {
    const response = await axiosFactory().post(`/auth/forgot-password`, { email });
    return response.data.data;
  }

  async confirmForgotPassword({ email, password, otp }) {
    const response = await axiosFactory().put(`/auth/confirm-forgot-password`, { email, password, otp });
    return response.data.data;
  }

  async verifyEmail({ token }) {
    const response = await axiosFactory().put(`/auth/verify-email/${token}`);
    if (response.data.statusCode === 200) {
      TokenService.setToken(response.data.data);
      return response.data.data;
    }
    return response.data.data;
  }
}

export default new AuthService();
